import React from "react";
import { Route, Redirect } from "react-router-dom";

import { authenticationService } from "../../services/authentication.service";

export const PrivateRoute = ({ component: Component, roles, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            const currentUser = authenticationService.currentUserValue;
            if (props.location !== "/login") {
                if (!currentUser || !authenticationService.currentUzivatel || !authenticationService.currentSklad) {
                    // not logged in so redirect to login page with the return url
                    authenticationService.clearAuthentication();
                    return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />;
                }
            }

            if (props.location !== "/login") {
                // check if route is restricted by role
                if (roles && roles.indexOf(currentUser.role) === -1) {
                    // role not authorised so redirect to home page
                    authenticationService.clearAuthentication();
                    return <Redirect to={{ pathname: "/" }} />;
                }
            }

            // authorised so return component
            return <Component {...props} />;
        }}
    />
);



// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute.js